import { memo } from 'react';
import { LuMap, LuMapPin } from 'react-icons/lu';
import { SidebarSection, SectionTitle, FlightTypeCard } from './FlightPlannerStyles';

/**
 * Step 2 — Flight Type selection panel.
 * User chooses between Orthomosaic (standard mapping) or DSP (sample plots).
 */
const WorkflowFlightType = ({ flightType, onFlightTypeSelect }) => (
	<SidebarSection>
		<SectionTitle>Select Flight Type</SectionTitle>
		<FlightTypeCard
			$selected={flightType === 'orthomosaic'}
			onClick={() => onFlightTypeSelect('orthomosaic')}>
			<h4>
				<LuMap size={16} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
				Orthomosaic
			</h4>
			<p>
				Standard mapping flight with overlapping images to create orthophotos and 3D models.
			</p>
		</FlightTypeCard>
		<FlightTypeCard $selected={flightType === 'dsp'} onClick={() => onFlightTypeSelect('dsp')}>
			<h4>
				<LuMapPin size={16} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
				DSP (Sample Plots)
			</h4>
			<p>Digital Sample Plot - fly to specific points for detailed data collection.</p>
		</FlightTypeCard>
	</SidebarSection>
);

export default memo(WorkflowFlightType);
